import theme from "@shared/utils/themeColors";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthenticatedLayout from "../../../shared/layouts/AuthenticatedLayout";
import DiagnosticTestCard from "../components/DiagnosticTestCard";
import { TestService } from "../services/test.service";

export default function DiagnosticTest() {
  const navigate = useNavigate();
  const [isRefreshing, setIsRefreshing] = useState(false);

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["diagnostic-test"],
    queryFn: () => TestService.getDiagnosticTest(),
    retry: false,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    staleTime: 0,
    refetchOnReconnect: true,
    gcTime: 0,
  });

  const handleRefresh = async () => {
    setIsRefreshing(true);
    await refetch();
    setIsRefreshing(false);
  };

  const handleStartTest = (testId: string, resume?: boolean) => {
    navigate(`/diagnostic-test/${testId}/take`);
  };

  return (
    <AuthenticatedLayout
      isLoading={isLoading || isRefreshing}
      error={error}
      isEmpty={!data?.test}
      emptyStateProps={{
        title: "No diagnostic test available",
        description: "There is no diagnostic test available at the moment.",
        icon: (
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-t from-gray-200 to-gray-100 mb-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className={`w-8 h-8 ${theme.text.muted}`}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
        ),
      }}
      pageHeader={{
        title: "Diagnostic Test",
        refresh: {
          show: true,
          onRefresh: handleRefresh,
        },
      }}
    >
      <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
        <div className="grid grid-cols-12 gap-6">
          {data?.test && (
            <DiagnosticTestCard test={data.test} onStart={handleStartTest} />
          )}
        </div>
      </div>
    </AuthenticatedLayout>
  );
}
